import React, {useState, useEffect} from 'react';
import './css/Message.css'
import Axios from "axios"
import {Alert, Form} from 'react-bootstrap'
import qs from 'qs'
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"


export default function Rsvp(){   
    
    const key = "6LcEuEIaAAAAAPomCOLxt5YrWYlIIpLOn793v0XX";
    const [rsvpName, setName] = useState("")
    const [attend, setAttend] = useState("1")
    const [plusOne, setPlusOne] = useState("0")
    const [ipAddress, setIp] = useState("")
    const [submitData, setData] = useState()
    const [buttonState, setButtonState] = useState('disabled')
    const [nameisInvalid, setNameInvalid] = useState(false)
    const [attendIsInvalid, setAttendInvalid] = useState(false)
    const [plusOneisInvalid, setPlusOneInvalid] = useState(false)
    const [showAlert, setAlert] = useState(false)
    const [alertSuccess, setAlertSuccess] = useState(false)
    const [isLoading, setLoading] = useState(false)

    useEffect(() =>{
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${key}`, function () {});
        getIp()
    },[])

    const getIp = () => {
        Axios.get('https://api.ipify.org/?format=json')
        .then((response) =>{
            
            setIp(response.data.ip);

        }).catch(function (error) {

            console.log(error);

        })
    }

    const loadScriptByURL = (id, url, callback) => {
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = url;
            script.id = id;
            script.onload = function () {
                if (callback) callback();
            };
            document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
    }

    const validateForm = (e) => {
        if(e.target.name === 'rsvpName'){
            setName(e.target.value)
        }else if(e.target.name === 'radioAttend'){
            setAttend(e.target.value)
        }else if(e.target.name === 'radioPlusOne'){
            setPlusOne(e.target.value);
        }
        
        if(rsvpName === '' || attend === '' || plusOne === ''){
            setButtonState('disabled')
        }else{
            setButtonState('')
        }
    }

    const handleClick = e => {
        
        if (rsvpName === '' || attend === '' || plusOne === '') {
            setButtonState('disabled')
            return false;
        }

        if (buttonState === 'disabled') {
            return false;
        }

        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(key, { action: 'submit' }).then(token => {
                submitRsvp(token);
            });
        });
    }

    const submitRsvp = token => {

        const data = {
            name: rsvpName,
            attend: attend,
            plusone: plusOne,
            ip: ipAddress,
            token: token,
        }
        
        var config = {
            method: 'post',
            url: 'https://sani-rijal-backend.herokuapp.com/api/rsvp/add',
            headers: { 
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: qs.stringify(data),
            transformRequest: [function (data, headers) {
                setLoading(true)
                setButtonState('disabled')
                return data
            }],
          }

        Axios(config).then(() => {
            setName('')
            setAttend('1')
            setPlusOne('0')
            setAlert(true)
            setAlertSuccess(true)
            setData([rsvpName,attend,plusOne])
            setLoading(false)
            setButtonState('disabled')
            setTimeout(() => {
                setAlert(false)
            }, 2000)

        }).catch(function (error) {
            setAlert(true)
            setAlertSuccess(false)
            setButtonState('disabled')
            setLoading(false)
            setTimeout(() => {
                setAlert(false)
            }, 2000)

        })
    }

    const checkInvalid = (e) => {
        if(e.target.name === 'rsvpName'){
            if(rsvpName === ''){
                setNameInvalid(true)
            }else{
                setNameInvalid(false)
            }
        }else if(e.target.name === 'radioAttend' || e.target.name === 'radioAttend'){
            if(attend === ''){
                setAttendInvalid(true)
            }else{
                setAttendInvalid(false)
            }
        }else if(e.target.name === 'radioPlusOne' || e.target.name === 'radioPlusOne'){
            if(plusOne === ''){
                setPlusOneInvalid(true)
            }else{
                setPlusOneInvalid(false)
            }
        }
    }

    return (
        <section className="pt-5 rsvp section-padding section-bg">
            <div className="container">
                <div className="row" data-aos="zoom-in" data-aos-delay="100">
                    <div className="col-md-12 text-center">
                        <h1 className="section-title">RSVP</h1>
                        <br/>
                    </div>
                </div>
                <Alert show={showAlert} className="text-center" variant={alertSuccess ? "success" : "danger"}>
                    {alertSuccess ? 'Thank you for confirming' : 'Failed to confirm'}
                </Alert>
                <div className="row" data-aos="zoom-in" data-aos-delay="100">
                    <div className="offset-md-4 col-md-4 text-center mb-3">
                        <div className="form-group">
                            <label className={nameisInvalid ? "text-danger" : ""}>Name</label>
                            <div className="input-group">
                                <input type="text" className={"form-control flat-design " + (nameisInvalid ? "is-invalid" : "") } id="rsvpName" name="rsvpName" value={rsvpName} onKeyUp={(e) => {validateForm(e);checkInvalid(e);}} onChange={validateForm}/>
                            </div>
                            <small id="nameError" className={nameisInvalid ? "text-danger" : ""}>{nameisInvalid ? "FIll out your name" : ""}</small>
                        </div>
                    </div>
                    <div className="col-md-12 mb-3 text-center">
                        <label className={attendIsInvalid ? "text-danger" : ""}>Will you be able to attend?</label>
                        <div className="form-group">
                            <div className="custom-control custom-radio custom-control-inline">
                                <Form.Check>
                                    <Form.Check.Input type="radio" id="radioAttendYes" name="radioAttend" value="1" checked={ attend === "1" ? true : false } onClick={(e) => {validateForm(e);checkInvalid(e);}} onChange={(e) => {validateForm(e);checkInvalid(e);}}/>
                                    <Form.Check.Label>Yes</Form.Check.Label>
                                </Form.Check>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <Form.Check>
                                    <Form.Check.Input type="radio" id="radioAttendNo" name="radioAttend" value="0" checked={ attend === "0" ? true : false} onClick={(e) => {validateForm(e);checkInvalid(e);}} onChange={(e) => {validateForm(e);checkInvalid(e);}}/>
                                    <Form.Check.Label>No</Form.Check.Label>
                                </Form.Check>
                            </div>
                        </div>
                    </div>
                    <div className="offset-md-3 col-md-6 text-center mb-3">
                        <label className={plusOneisInvalid ? "text-danger" : ""}>Will you be bringing plus one?</label>
                        <div className="form-group">
                            <div className="custom-control custom-radio custom-control-inline">
                                <Form.Check>
                                    <Form.Check.Input type="radio" name="radioPlusOne" id="radioPlusOneYes" value="1" checked={ plusOne === "1"} onClick={(e) => {validateForm(e);checkInvalid(e);}} onChange={(e) => {validateForm(e);checkInvalid(e);}}/>
                                    <Form.Check.Label>Yes</Form.Check.Label>
                                </Form.Check>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <Form.Check>
                                    <Form.Check.Input type="radio" name="radioPlusOne" id="radioPlusOneNo" value="0" checked={ plusOne === "0"} onClick={(e) => {validateForm(e);checkInvalid(e);}} onChange={(e) => {validateForm(e);checkInvalid(e);}}/>
                                    <Form.Check.Label>No</Form.Check.Label>
                                </Form.Check>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 text-center">
                        <span className={'btn btn-sm btn-primary ' + buttonState} onClick={handleClick}>Send RSVP {isLoading ? <FontAwesomeIcon icon={faCircleNotch} spin/> : ''}</span>
                    </div>
                </div>
            </div>
        </section>
    )
}